import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

// styles
import "../project/Project.css";
import "./VendorInvoices.css";

// components
import VendorInvoiceRows from "./VendorInvoiceRows";
import Loading from "../../components/Loading";
import ErrorDisplay from "../../components/ErrorDisplay";
import InvoiceStatusFilter from "../../invoiceComponents/InvoiceStatusFilter";
import DeletePopup from "../../components/DeletePopup";
import UpdatePopup from "../../components/UpdatePopup";

// data
import { vendorInvoiceStatus } from "../../data/collections-data";

// global
import {
  accountDataStore,
  companyStore,
  projectStore,
} from "../../store/Store";

// hooks
import useGetFetch from "../../hooks/useGetFetch";
import AddAdjustment from "../account-invoices/AddAdjustment";
import SelectFscMethodForDownload from "../../invoiceComponents/SelectFscMethodForDownload";

export default function VendorInvoiceList({ invoiceType }) {
  const projectVendorInvoices = projectStore(
    (data) => data.projectVendorInvoices,
  );
  const setProjectVendorInvoices = projectStore(
    (data) => data.setProjectVendorInvoices,
  );
  const setProjectVendorInvoiceTotals = projectStore(
    (data) => data.setProjectVendorInvoiceTotals,
  );
  const setInvoiceAdjustments = accountDataStore(
    (data) => data.setInvoiceAdjustments,
  );
  const currentProject = projectStore((data) => data.currentProject);
  const setProjectLoads = projectStore((data) => data.setProjectLoads);
  const setProjectAssetLoads = projectStore(
    (data) => data.setProjectAssetLoads,
  );
  const invoiceCounts = companyStore((data) => data.invoiceCounts);
  const setInvoiceCounts = companyStore((data) => data.setInvoiceCounts);

  const [filter, setFilter] = useState("in_progress");
  const [displayInvoices, setDisplayInvoices] = useState([]);
  const [deleteTrigger, setDeleteTrigger] = useState(false);
  const [deleteId, setDeleteId] = useState(0);
  const [updateBody, setUpdateBody] = useState();
  const [updateTrigger, setUpdateTrigger] = useState(false);
  const [adjustmentTrigger, setAdjustmentTrigger] = useState(false);
  const [fscMethodTrigger, setFscMethodTrigger] = useState(false);
  const [fscMethod, setFscMethod] = useState(0);
  const { id } = useParams("id");
  // get invoice counts
  const { isPending: countsPending, error: countsError } = useGetFetch(
    `${process.env.REACT_APP_BACKEND}/lc/invoice-counts/${id}`,
    setInvoiceCounts,
  );
  
  const { isPending: adjustmentsPending, error: adjustmentsError } =
    useGetFetch(
      `${process.env.REACT_APP_BACKEND}/lc/invoice-adjustments/${id}?is_vendor=true&is_received=false`,
      setInvoiceAdjustments,
    );
  // filter invoices based on status
  useEffect(() => {
    var invoices = [];
    if (
      projectVendorInvoices &&
      projectVendorInvoices.invoices &&
      invoiceType === "Freight"
    ) {
      switch (filter) {
        case "in_progress":
          invoices = projectVendorInvoices.invoices.filter(
            (x) => x.invoice_status_id === 32 && !x.is_asset,
          );
          break;
        case "approved":
          invoices = projectVendorInvoices.invoices.filter(
            (x) => x.invoice_status_id === 29 && !x.is_asset,
          );
          break;
        case "paid":
          invoices = projectVendorInvoices.invoices.filter(
            (x) => x.invoice_status_id === 31 && !x.is_asset,
          );
          break;
        case "disputed":
          invoices = projectVendorInvoices.invoices.filter(
            (x) => x.invoice_status_id === 30 && !x.is_asset,
          );
          break;
        default:
          invoices = projectVendorInvoices.invoices.filter(
            (x) => x.invoice_status_id === 32 && !x.is_asset,
          );
      }
    } else if (
      projectVendorInvoices &&
      projectVendorInvoices.invoices &&
      invoiceType === "Asset"
    ) {
      switch (filter) {
        case "in_progress":
          invoices = projectVendorInvoices.invoices.filter(
            (x) => x.invoice_status_id === 32 && x.is_asset,
          );
          break;
        case "approved":
          invoices = projectVendorInvoices.invoices.filter(
            (x) => x.invoice_status_id === 29 && x.is_asset,
          );
          break;
        case "paid":
          invoices = projectVendorInvoices.invoices.filter(
            (x) => x.invoice_status_id === 31 && x.is_asset,
          );
          break;
        case "disputed":
          invoices = projectVendorInvoices.invoices.filter(
            (x) => x.invoice_status_id === 30 && x.is_asset,
          );
          break;
        default:
          invoices = projectVendorInvoices.invoices.filter(
            (x) => x.invoice_status_id === 32 && x.is_asset,
          );
      }
    } else if (
      projectVendorInvoices &&
      projectVendorInvoices.invoices &&
      invoiceType === "Sand"
    ) {
      switch (filter) {
        case "in_progress":
          invoices = projectVendorInvoices.invoices.filter(
            (x) => x.invoice_status_id === 32 && x.is_sand,
          );
          break;
        case "approved":
          invoices = projectVendorInvoices.invoices.filter(
            (x) => x.invoice_status_id === 29 && x.is_sand,
          );
          break;
        case "paid":
          invoices = projectVendorInvoices.invoices.filter(
            (x) => x.invoice_status_id === 31 && x.is_sand,
          );
          break;
        case "disputed":
          invoices = projectVendorInvoices.invoices.filter(
            (x) => x.invoice_status_id === 30 && x.is_sand,
          );
          break;
        default:
          invoices = projectVendorInvoices.invoices.filter(
            (x) => x.invoice_status_id === 32 && x.is_sand,
          );
      }
    }
    setDisplayInvoices(invoices);
  }, [projectVendorInvoices, invoiceType, filter]);

  if (countsPending || adjustmentsPending) {
    return <Loading />;
  }
  if (countsError || adjustmentsError) {
    return <ErrorDisplay message={"Something went wrong"} code={500} />;
  }

  return invoiceType === "Freight" ? (
    <div className="container-fluid">
      {projectVendorInvoices && projectVendorInvoices.invoices ? (
        <div className="row g-2">
          <div className="load-display-list">
            <InvoiceStatusFilter
              setFilter={setFilter}
              invoiceCounts={invoiceCounts.vendor_freight_counts}
            />
            {displayInvoices.length > 0 && (
              <table className="table table-sm table-hover">
                <thead>
                  <tr>
                    <th>Vendor</th>
                    <th>Name</th>
                    <th>Loads</th>
                    <th>Duplicates Tickets</th>
                    <th>Duplicates Loads</th>
                    <th>Missing Ticket</th>
                    <th>Missing Loads</th>
                    <th>Canceled Loads</th>
                    <th>Locked Loads</th>
                    <th>Weight</th>
                    <th>Calc Weight</th>
                    <th>Weight Diff</th>
                    <th>Freight $</th>
                    <th>FSC $</th>
                    <th>Gross $</th>
                    <th>Calculated Cost $</th>
                    <th>Difference $</th>
                    <th>Adjustment $</th>
                    <th>Net $</th>
                    <th>Discount</th>
                    <th>Client Approval</th>
                    <th className="approval-col">Status Update</th>
                    {!currentProject.project.archived && <th>Action</th>}
                  </tr>
                </thead>
                <tbody>
                  <VendorInvoiceRows
                    invoiceType={invoiceType}
                    setDeleteTrigger={setDeleteTrigger}
                    setDeleteId={setDeleteId}
                    displayInvoices={displayInvoices}
                    setUpdateBody={setUpdateBody}
                    setUpdateTrigger={setUpdateTrigger}
                    setAdjustmentTrigger={setAdjustmentTrigger}
                    setFscMethodTrigger={setFscMethodTrigger}
                    fscMethod={fscMethod}
                    fscMethodTrigger={fscMethodTrigger}
                  />
                </tbody>
              </table>
            )}
            {updateTrigger && (
              <UpdatePopup
                setTrigger={setUpdateTrigger}
                url={`${process.env.REACT_APP_BACKEND}/pc/vendor-invoice/${updateBody.id}?is_received=false`}
                method={"PATCH"}
                title={`Are you sure you want to update ${updateBody.invoice_name} to ${
                  vendorInvoiceStatus[updateBody.invoice_status_id]
                }`}
                errorMessage={"Could not Update"}
                successMessage={"Status Changed"}
                setStates={[
                  setProjectVendorInvoices,
                  setProjectVendorInvoiceTotals,
                  setInvoiceCounts,
                ]}
                setStateFields={[
                  "vendor_invoices",
                  "vendor_invoice_totals",
                  "invoice_counts",
                ]}
                body={updateBody}
              />
            )}
            {deleteTrigger && (
              <DeletePopup
                setTrigger={setDeleteTrigger}
                id={deleteId}
                table="project_vendor_invoice_tbl"
                endpoint="vendor/invoice"
                nameField="invoice_name"
                projectId={currentProject.project.id}
                setDocId={setDeleteId}
                setStates={[
                  setProjectVendorInvoices,
                  setProjectVendorInvoiceTotals,
                  setInvoiceCounts,
                  setProjectLoads,
                  setProjectAssetLoads,
                ]}
                setStateFields={[
                  "invoice_data",
                  "project_vendor_invoice_totals",
                  "invoice_counts",
                  "project_loads",
                  "project_asset_loads",
                ]}
              />
            )}
            {adjustmentTrigger && (
              <AddAdjustment
                inv={updateBody}
                setTrigger={setAdjustmentTrigger}
                projectId={currentProject.project.id}
                isVendor={true}
                id={0}
                batchInvoices={null}
              />
            )}
            {fscMethodTrigger && (
              <SelectFscMethodForDownload
                setFscMethodTrigger={setFscMethodTrigger}
                setFscMethod={setFscMethod}
              />
            )}
          </div>
        </div>
      ) : (
        <div>No Invoices to Display</div>
      )}
    </div>
  ) : invoiceType === "Asset" ? (
    <div className="container-fluid">
      {projectVendorInvoices.invoices ? (
        <div className="row g-2">
          <div className="load-display-list">
            <InvoiceStatusFilter
              setFilter={setFilter}
              invoiceCounts={invoiceCounts.vendor_asset_counts}
            />
            {displayInvoices.length > 0 && (
              <table className="table table-sm table-hover">
                <thead>
                  <tr>
                    <th>Vendor</th>
                    <th>Name</th>
                    <th>Loads</th>
                    <th>Duplicates Loads</th>
                    <th>Missing Loads</th>
                    <th>Locked Loads</th>
                    <th>Weight</th>
                    <th>Calc Weight</th>
                    <th>Weight Diff</th>
                    <th>Freight $</th>
                    <th>FSC $</th>
                    <th>Gross $</th>
                    <th>Calculated Cost $</th>
                    <th>Difference $</th>
                    <th>Adjustment $</th>
                    <th>Net $</th>
                    <th>Discount</th>
                    <th>Client Approval</th>
                    <th className="approval-col">Approval</th>
                    {!currentProject.project.archived && <th>Action</th>}
                  </tr>
                </thead>
                <tbody>
                  <VendorInvoiceRows
                    invoiceType={invoiceType}
                    setDeleteTrigger={setDeleteTrigger}
                    setDeleteId={setDeleteId}
                    displayInvoices={displayInvoices}
                    setUpdateBody={setUpdateBody}
                    setUpdateTrigger={setUpdateTrigger}
                  />
                </tbody>
              </table>
            )}
            {updateTrigger && (
              <UpdatePopup
                setTrigger={setUpdateTrigger}
                url={`${process.env.REACT_APP_BACKEND}/pc/vendor-invoice/${updateBody.id}?is_received=false`}
                method={"PATCH"}
                title={`Are you sure you want to update ${updateBody.invoice_name} to ${
                  vendorInvoiceStatus[updateBody.invoice_status_id]
                }`}
                errorMessage={"Could not Update"}
                successMessage={"Status Changed"}
                setStates={[
                  setProjectVendorInvoices,
                  setProjectVendorInvoiceTotals,
                  setInvoiceCounts,
                ]}
                setStateFields={[
                  "vendor_invoices",
                  "vendor_invoice_totals",
                  "invoice_counts",
                ]}
                body={updateBody}
              />
            )}
            {deleteTrigger && (
              <DeletePopup
                setTrigger={setDeleteTrigger}
                id={deleteId}
                table="project_vendor_invoice_tbl"
                endpoint="vendor/invoice"
                nameField="invoice_name"
                projectId={currentProject.project.id}
                setDocId={setDeleteId}
                setStates={[
                  setProjectVendorInvoices,
                  setProjectVendorInvoiceTotals,
                  setInvoiceCounts,
                  setProjectLoads,
                  setProjectAssetLoads,
                ]}
                setStateFields={[
                  "invoice_data",
                  "project_vendor_invoice_totals",
                  "invoice_counts",
                  "project_loads",
                  "project_asset_loads",
                ]}
              />
            )}
            {adjustmentTrigger && (
              <AddAdjustment
                inv={updateBody}
                setTrigger={setAdjustmentTrigger}
                projectId={currentProject.project.id}
                isVendor={true}
                id={0}
                batchInvoices={null}
              />
            )}
          </div>
        </div>
      ) : (
        <div>No Invoices to Display</div>
      )}
    </div>
  ) : (
    invoiceType === "Sand" && (
      <div className="container-fluid">
        {projectVendorInvoices.invoices ? (
          <div className="row g-2">
            <div className="load-display-list">
              <InvoiceStatusFilter
                setFilter={setFilter}
                invoiceCounts={invoiceCounts.vendor_sand_counts}
              />
              {displayInvoices.length > 0 && (
                <table className="table table-sm table-hover">
                  <thead>
                    <tr>
                      <th>Vendor</th>
                      <th>Name</th>
                      <th>Loads</th>
                      <th>Duplicates Tickets</th>
                      <th>Duplicates Loads</th>
                      <th>Missing Ticket</th>
                      <th>Missing Loads</th>
                      <th>Canceled Loads</th>
                      <th>Locked Loads</th>
                      <th>Weight</th>
                      <th>Calc Weight</th>
                      <th>Weight Diff</th>
                      <th>Sand $</th>
                      <th>Gross $</th>
                      <th>Calculated Cost $</th>
                      <th>Difference $</th>
                      <th>Adjustment $</th>
                      <th>Net $</th>
                      <th>Discount</th>
                      <th className="approval-col">Approval</th>
                      {!currentProject.project.archived && <th>Action</th>}
                    </tr>
                  </thead>
                  <tbody>
                    <VendorInvoiceRows
                      invoiceType={invoiceType}
                      setDeleteTrigger={setDeleteTrigger}
                      setDeleteId={setDeleteId}
                      displayInvoices={displayInvoices}
                      setUpdateBody={setUpdateBody}
                      setUpdateTrigger={setUpdateTrigger}
                    />
                  </tbody>
                </table>
              )}
              {updateTrigger && (
                <UpdatePopup
                  setTrigger={setUpdateTrigger}
                  url={`${process.env.REACT_APP_BACKEND}/pc/vendor-invoice/${updateBody.id}?is_received=false`}
                  method={"PATCH"}
                  title={`Are you sure you want to update ${updateBody.invoice_name} to ${
                    vendorInvoiceStatus[updateBody.invoice_status_id]
                  }`}
                  errorMessage={"Could not Update"}
                  successMessage={"Status Changed"}
                  setStates={[
                    setProjectVendorInvoices,
                    setProjectVendorInvoiceTotals,
                    setInvoiceCounts,
                  ]}
                  setStateFields={[
                    "vendor_invoices",
                    "vendor_invoice_totals",
                    "invoice_counts",
                  ]}
                  body={updateBody}
                />
              )}
              {deleteTrigger && (
                <DeletePopup
                  setTrigger={setDeleteTrigger}
                  id={deleteId}
                  table="project_vendor_invoice_tbl"
                  endpoint="vendor/invoice"
                  nameField="invoice_name"
                  projectId={currentProject.project.id}
                  setDocId={setDeleteId}
                  setStates={[
                    setProjectVendorInvoices,
                    setProjectVendorInvoiceTotals,
                    setInvoiceCounts,
                    setProjectLoads,
                    setProjectAssetLoads,
                  ]}
                  setStateFields={[
                    "invoice_data",
                    "project_vendor_invoice_totals",
                    "invoice_counts",
                    "project_loads",
                    "project_asset_loads",
                  ]}
                />
              )}
              {adjustmentTrigger && (
                <AddAdjustment
                  inv={updateBody}
                  setTrigger={setAdjustmentTrigger}
                  projectId={currentProject.project.id}
                  isVendor={true}
                  id={0}
                  batchInvoices={null}
                />
              )}
            </div>
          </div>
        ) : (
          <div>No Invoices to Display</div>
        )}
      </div>
    )
  );
}
